module.exports = __webpack_public_path__ + "img/GDQ-svarsstapel_90.f5f281ca.gif";